import {uploadUrlToOSS} from "@/components/file_process_js/api";
import {getTxtThumbnailUrlFromPath} from "@/components/thumbnail/getFlieThumbnailUrl"
import {fileStatusChange, getBaseName} from "@/components/file_process_js/utils";


export async function txtFileVisionProcess(fileInfo) {
    const pngUrl = await getTxtThumbnailUrlFromPath(fileInfo.file_path);
    const imageKey = `${fileInfo.project_id}/converted/txt/${getBaseName(fileInfo.file_path)}.png`
    if (pngUrl) {
        try {
            fileStatusChange(fileInfo, "img uploading", 110)
            const uploadRes = await uploadUrlToOSS(fileInfo.project_id, pngUrl, imageKey)
            if (uploadRes.error) {
                console.error("uploadUrlToOSS error", uploadRes.error)
                fileStatusChange(fileInfo, "img_upload_failed", -112)
                return ""
            } else {
                fileStatusChange(fileInfo, "img_uploaded", 190)
                return imageKey
            }
        } catch (err) {
            console.error("txtFileVisionProcess error", err)
            fileStatusChange(fileInfo, "img_upload_failed", -111)
            return ""
        }
    }
}

